import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import download from 'downloadjs'

import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import common_helper from '../../../common_helper'
Vue.component("downloadExcel", JsonExcel);


export default {
  name: 'RejectedOrder',
  components: {
    //	Paginate,
    Pagination,
    DatePicker,
    download,
    Loader,
    BasicSelect
  },
  data: function () {
    return {
      sourcetype: '',
      ponoFlt: '',
      shipidflt: '',
      searchchannel: '',
      searchstatus: '',
      fromDateFlt: '',
      toDateFlt: '',
      fromDateFltStatus: '',
      toDateFltStatus: '',
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: 10,
      totalRows: 0,
      listOrderMasterDataCsv: [],
      listOrderMasterData: [],
      listInwardDetailData: [],
      channellist: [],
      fromdate: '',
      todate: '',
      merchant: '',
      drstatus: '',
      quantity: '',
      isLoading: false,
      listMerchantData: [],
      listClientData: [],
      listWarehouseData: [],
      // pageCount: 0,
      // pageNo: 0,
      pageNoDetail: 0,
      // pageLimit: 10,
      client: '',
      formattedDate: '',
      clientid: '',
      warehouse: '',
      warehouseid: '',
      showSelectClient: false,
      showSelectWarehouse: false,
      clientList: [],
      warehouseList: [],
      merchantList: [],
      ClientErr: '',
      WarehouseErr: '',
      merchantid: '',
      csvFieldsForXls: {},
      download: true,
      reportname: '',
      show: false,
      dataFilter2: '',
      listReportDataforxls: [],
      isLoadingforxls: false,
      orderstatuslist: [{
        'status': 'created'
      }, {
        'status': 'allocated'
      }, {
        'status': 'picked'
      }, {
        'status': 'packed'
      }, {
        'status': 'dispatched'
      }, {
        'status': 'cancelled'
      }, {
        'status': 'rto'
      }],
      statusFlag: false,
      item: {
        value: '',
        text: ''
      },
      listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],

    }
  },
  beforeCreate: function () {
    this.isLoading = true;
  },

  created: function () { },
  filters: {
    moment: function (date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    }
  },
  // when a page loads,mounted() will be call
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail.userid;
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    this.reportname = this.$t('editedjson.rejectorderreport')
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
    this.getSalesChannels();
    }
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.getMerchantList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.warehouseid = userdetail.warehouseid;
        this.warehousename = userdetail.fullname;

        // this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError'));
        break
    }
    this.calldateFunction();
  },
  methods: {
    reset() {
      this.item = {}
    },
    onSelect(item) {
      // select option from parent component
      this.item = item
      this.merchant = item.value;

    },
    calldateFunction() {
      //console.log("sagar")
      this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      this.toDateFlt = this.currentDate;
      var dt = new Date(this.currentDate);
      dt.setDate(dt.getDate() - 6);
      this.fromDateFlt = dt;

    },
    // getWarehouseList() {
    //   var userToken = window.localStorage.getItem('userToken')
    //   var myStr = userToken.replace(/"/g, '');
    //   this.pageNo = this.pageCount = 0;

    //   this.input = ({
    //     clientid: this.clientid,
    //   });

    //   axios({
    //     method: 'POST',
    //     'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //     'data': this.input,
    //     headers: {
    //       'Authorization': 'Bearer ' + myStr
    //     }
    //   })
    //     .then(result => {
    //       if (result.data.data && result.data.data.length > 0) {
    //         this.listWarehouseData = result.data.data;
    //         var warehouseListArray = [];
    //         result.data.data.forEach(function (item) {
    //           warehouseListArray[item.warehouseid] = item.warehousename;
    //         });
    //         this.warehouseList = warehouseListArray;
    //       }
    //     }, error => {
    //       console.error(error)
    //     })
    // },

    // getClientList() {
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     var clientList = JSON.parse(plaintextclient);
    //     var clientListArray = [];
    //     clientList.forEach(function (item) {
    //       clientListArray[item.clientid] = item.clientname;
    //     });
    //     this.clientList = clientListArray;
    //     this.listClientData = clientList;
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageNo = this.pageCount = 0;

    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });

    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         if (result.data.data && result.data.data.length > 0) {
    //           this.listClientData = result.data.data;

    //           var clientListArray = [];
    //           result.data.data.forEach(function (item) {
    //             clientListArray[item.clientid] = item.clientname;
    //           });

    //           this.clientList = clientListArray;
    //         }
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     //this.totalRows=[]
    //     if (this.clientid)
    //       this.getMerchantList();
    //     this.getSalesChannels();
    //     this.merchant = '';

    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();

    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid);
    //       // this.getCancelPutAwayPendingData();
    //     }
    //   }
    //   this.getMerchantList()
    //   this.listOrderMasterData = [];
    //   this.pageNo = this.pageCount = 0;
    // },

    // warehouseSelected() {
    //   this.totalRows = 0
    //   this.warehouseid = this.warehouse;
    //   this.pageNo = this.pageCount = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       this.getSalesChannels();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },

    getMerchantList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'merchantList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data && result.data.length > 0) {
            this.listMerchantData = result.data;
            var merchantListArray = [];
            result.data.forEach(function (item) {
              merchantListArray[item.merchantid] = item.merchantname;
            });
            this.merchantList = merchantListArray;
            this.merchantList = merchantListArray;
            this.item = {
              value: '',
              text: ''
            },
              this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
            this.listMerchantData.forEach(ele => {
              this.listMerchantData1.push({
                "value": ele.merchantid,
                "text": ele.merchantname

              })
            })


          }
        }, error => {
          console.error(error)
        })
    },
    getOrderSerach() {
      this.currentPage = 1;
      this.getOrderMasterData();
    },
    dateFormat1(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 00:00:00";
    },
    dateFormat2(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 23:59:59";
    },
    jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = []) {
      var csvData = '';
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ',';
      }
      csvData = csvData.slice(0, csvData.length - 1);
      csvData += '\r\n';
      //Data
      data.map(function (item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + ''; // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilter.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
              else
                csvData += escapedCSV + ',';
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n');
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData;
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    //to get inward master data
    getOrderMasterData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (csvCheck !== 1) {
        this.show = false;
        this.download = true;
      }
      var dataFilter = {};
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.pageCount = 0;
        this.listOrderMasterData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.pageCount = 0;
        this.listOrderMasterData = [];
        return false;
      }
      var fr_date = '';
      var to_date = '';
      var frstatus_date = '';
      var tostatus_date = '';
      if (this.fromDateFlt != '' && this.fromDateFlt != null) {
        fr_date = this.dateFormat(this.fromDateFlt) + " 00:00:00";
      }
      if (this.toDateFlt != '' && this.toDateFlt != null) {
        to_date = this.dateFormat(this.toDateFlt) + " 23:59:59";
      }
      if (this.fromDateFltStatus != '' && this.fromDateFltStatus != null) {
        frstatus_date = this.dateFormat(this.fromDateFltStatus) + " 00:00:00";
      }
      if (this.toDateFltStatus != '' && this.toDateFltStatus != null) {
        tostatus_date = this.dateFormat(this.toDateFltStatus) + " 23:59:59";
      }
      this.isLoading = true;
      if (this.user_type == 'system_user') {
        this.warehouseid = this.warehouseid
      }
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        sourcetype: this.sourcetype,
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        ponoFlt: this.ponoFlt.trim(),
        shipidflt: this.shipidflt.trim(),
        saleschannel: this.searchchannel,
        searchstatus: this.searchstatus,
        fromDateFlt: fr_date,
        toDateFlt: to_date,
        fromDateFltStatus: frstatus_date,
        toDateFltStatus: tostatus_date,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
        userid: this.userid,
        merchantid: this.merchant,

      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'GetRejectorderList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          this.isLoading = false;
          if (csvCheck == 1) {
            this.show = true;
            this.download = false;
            if (result.data.data.length > 0) {

              this.csvFields = {
                'brandsku': this.$t('product.clientProductId'),
                'case': this.$t('orders.source'),
                'createddatetime': this.$t('consolidation.createdDatetime'),
                'eancode': this.$t('common.eanCode'),
                'linestatus': this.$t('stockTransfer.lineStatus'),
                'orderdate': this.$t('common.orderDate'),
                'orderid': this.$t('common.orderID'),
                'orderitemid': this.$t('packingReportList.table.columns.orderItemId'),
                'productid': this.$t('common.productId'),
                'quantity': this.$t('common.quantity'),
                'rejecteddate': this.$t('grcRejectReport.rejectedDate'),
                'rejectedreasons': this.$t('shipment.rejectedReasons'),
                'saleschannel': this.$t('common.salesChannel'),
                'shipmentid': this.$t('common.shipmentId'),
                'status': this.$t('common.status'),
                'merchantname': this.$t('common.merchant')
              };

              var dateFilter = [];
              var skipFilter = ['shipmentstatusct', 'shipmentstatus', 'warehouseid'];
              this.listOrderMasterDataCsv = result.data.data;
              for (var i = 0; i < this.listOrderMasterDataCsv.length; i++) {
                if (this.listOrderMasterDataCsv[i].source == 0) {
                  this.listOrderMasterDataCsv[i].source = 'CSV'
                }
                if (this.listOrderMasterDataCsv[i].source == 1) {
                  this.listOrderMasterDataCsv[i].source = 'Unicommerce'
                }
                if (this.listOrderMasterDataCsv[i].source == 2) {
                  this.listOrderMasterDataCsv[i].source = 'Rubicon'
                }
                if (this.listOrderMasterDataCsv[i].source == '') {
                  this.listOrderMasterDataCsv[i].source = 'CSV'
                }
              }
              this.jsonToCSV(this.$t('editedjson.rejectedOrder'), this.listOrderMasterDataCsv, this.csvFields, dateFilter, skipFilter);
            } else {
              if (result.data.status == true) {
                this.$alertify.success(this.$t('common.reportSizeError'));
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }
          } else {
            this.listOrderMasterData = result.data.data;
            this.totalRows = result.data.count;
            // this.setDataPageCounts(result.data.count);
            if (this.totalRows > 0) {
              if (this.totalRows <= this.pageLimit) {
                this.totalPage = 1;
              } else {
                this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
              }
            } else {
              this.totalPage = 0;
            }
          }

        }, error => {
          console.error(error)
        })
    },
    async PullRejectOrders(data) {
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        saleschannel: data.saleschannel,
        orderid: data.orderid
      })
      this.isLoading = true;
      let result = await common_helper.getRestApiResponse('POST', 'pullRejectedOrder', this.input, this.$alertify)
      if (result && !result.errorDATA) {
        this.isLoading = false;
        if (result.data.status == true) {
          this.$alertify.success(result.data.msg)
        } else {
          this.$alertify.error(result.data.msg)
        }
        this.getOrderMasterData()
      }
    },
    Choosetype() {
      this.show = true;
      this.download = false;
      this.getPickingreportDataForXls(3)
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    getPickingreportDataForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      var fr_date = '';
      var to_date = '';
      var frstatus_date = '';
      var tostatus_date = '';
      if (this.fromDateFlt != '' && this.fromDateFlt != null) {
        fr_date = this.dateFormat(this.fromDateFlt) + " 00:00:00";
      }
      if (this.toDateFlt != '' && this.toDateFlt != null) {
        to_date = this.dateFormat(this.toDateFlt) + " 23:59:59";
      }
      if (this.fromDateFltStatus != '' && this.fromDateFltStatus != null) {
        frstatus_date = this.dateFormat(this.fromDateFltStatus) + " 00:00:00";
      }
      if (this.toDateFltStatus != '' && this.toDateFltStatus != null) {
        tostatus_date = this.dateFormat(this.toDateFltStatus) + " 23:59:59";
      }
      // this.ClientErr = '';
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        sourcetype: this.sourcetype,
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        ponoFlt: this.ponoFlt.trim(),
        shipidflt: this.shipidflt.trim(),
        saleschannel: this.searchchannel,
        searchstatus: this.searchstatus,
        fromDateFlt: fr_date,
        toDateFlt: to_date,
        fromDateFltStatus: frstatus_date,
        toDateFltStatus: tostatus_date,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
        merchantid: this.merchant,
        userid: this.userid,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'GetRejectorderList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 3) {
            if (result.data.data.length > 0) {
              this.listReportDataforxls = [];
              this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
              this.csvFieldsForXls[this.$t('common.merchant')] = 'merchantname';
              this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel';
              this.csvFieldsForXls[this.$t('common.orderDate')] = 'orderdate';
              this.csvFieldsForXls[this.$t('grcRejectReport.rejectedDate')] = 'rejecteddate';
              this.csvFieldsForXls[this.$t('product.clientProductId')] = 'brandsku';
              this.csvFieldsForXls[this.$t('common.shipmentId')] = 'shipmentid';
              this.csvFieldsForXls[this.$t('packingReportList.table.columns.orderItemId')] = 'orderitemid';
              this.csvFieldsForXls[this.$t('common.productId')] = 'productid';
              this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
              this.csvFieldsForXls[this.$t('common.quantity')] = 'quantity';
              this.csvFieldsForXls[this.$t('shipment.rejectedReasons')] = 'rejectedreasons';
              this.csvFieldsForXls[this.$t('orders.source')] = 'case';
              this.csvFieldsForXls[this.$t('common.status')] = 'status';

              this.listReportDataforxls = result.data.data;
            } else {
              if (result.data.status == true) {
                this.$alertify.success(this.$t('common.reportSizeError'));
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }
          }
        },
          error => {
            console.error(error)
          })
    },

    //to get client list
    getOrderMasterDataSearch() {
      this.pageNo = this.pageCount = 0;
      this.getOrderMasterData();
    },

    getSalesChannels() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      if (window.localStorage.getItem("selectedClient") == '') {
        this.WarehouseErr = this.$t('srReport.clientError');
        return false;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'orderSalesChannelList',
        'data': {
          clientid: window.localStorage.getItem("selectedClient")
        },
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          this.channellist = result.data.data;
        }, error => {
          console.error(error);
        });
    },
    hideShowdateFlt() {
      if (this.searchstatus == "created") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = false;
        this.labelfromdate = '';
        this.labeltodate = '';
      }
      if (this.searchstatus == "allocated") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.allocatedFromDate');
        this.labeltodate = this.$t('editedjson.allocatedToDate');
      }
      if (this.searchstatus == "picked") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('cancelPutawayPendingReport.pickedFromDate');
        this.labeltodate = this.$t('cancelPutawayPendingReport.pickedToDate');
      }
      if (this.searchstatus == "packed") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.packedFromDate');
        this.labeltodate = this.$t('editedjson.packedToDate');
      }
      if (this.searchstatus == "dispatched") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.dispatchedFromDate');
        this.labeltodate = this.$t('editedjson.dispatchedToDate');
      }
      if (this.searchstatus == "cancelled") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('cancelPutawayPendingReport.cancelledFromDate');
        this.labeltodate = this.$t('cancelPutawayPendingReport.cancelledToDate');
      }
      if (this.searchstatus == "rto") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('srReport.rTOFromDate');
        this.labeltodate = this.$t('srReport.rTOToDate');
      }
    },


    resetOrderSerach() {
      this.item = {
        value: '',
        text: ''
      };
      // this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
      this.totalRows = 0;
      this.download = true;
      this.ponoFlt = '';
      this.shipidflt = '';
      this.searchchannel = '';
      this.searchstatus = '';
      this.fromDateFlt = '';
      this.toDateFlt = '';
      this.sourcetype = '';
      this.merchant = '';
      this.fromDateFltStatus = '';
      this.toDateFltStatus = '';
      this.pageNo = this.pageCount = 0;
      this.pageNoDetail = this.pageCountDetail = 0;
      this.listOrderMasterData = [];
      this.listInwardDetailData = [];
      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
    },

    onPageChange(page) {
      this.currentPage = page;
      this.getOrderMasterData()
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },



    //validate all form fields on onsubmit()
    onSubmit: function (event) {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
        event.target.reset();
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/views/components/rejectorderlist/rejectorderlist.component.js